/*کارخانه*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={93.278}
      height={93.278}
      viewBox="0 0 93.278 93.278"
      {...props}
    >
      <path
        data-name="Path 7823"
        d="M56.23 91.912H41.88V20.159a1.735 1.735 0 011.735-1.735h10.881a1.735 1.735 0 011.736 1.735v71.753z"
        fill="#c3d5ef"
      />
      <path
        data-name="Path 7824"
        d="M54.495 18.424H51.48a1.735 1.735 0 011.735 1.735v71.753h3.016V20.159a1.735 1.735 0 00-1.736-1.735z"
        fill="#b7c8ea"
      />
      <path
        data-name="Path 7825"
        d="M41.856 37.871h14.4v12.524h-14.4z"
        fill="#df6b57"
      />
      <path
        data-name="Path 7826"
        d="M53.214 37.871h3.017v12.524h-3.017z"
        fill="#dd544f"
      />
      <path
        data-name="Path 7827"
        d="M41.856 65.757h14.4v12.52h-14.4z"
        fill="#df6b57"
      />
      <path
        data-name="Path 7828"
        d="M53.214 65.757h3.017v12.52h-3.017z"
        fill="#dd544f"
      />
      <path
        data-name="Path 7829"
        d="M23.118 91.909H8.767V12.871a1.735 1.735 0 011.735-1.735h10.881a1.735 1.735 0 011.735 1.735v79.038z"
        fill="#c3d5ef"
      />
      <path
        data-name="Path 7830"
        d="M21.384 11.136h-3.752a1.734 1.734 0 011.735 1.735v79.038h3.753V12.871a1.735 1.735 0 00-1.736-1.735z"
        fill="#b7c8ea"
      />
      <path
        data-name="Path 7831"
        d="M23.122 33.009h18.761v4.61H23.122z"
        fill="#365e7d"
      />
      <path
        data-name="Path 7832"
        d="M38.864 33.009h3.015v4.61h-3.015z"
        fill="#2b4d66"
      />
      <path
        data-name="Path 7833"
        d="M44.966 75.456h21.885V80.1H44.966z"
        fill="#365e7d"
      />
      <path
        data-name="Path 7834"
        d="M66.853 75.456h-5.754a27.419 27.419 0 00.024 4.644h5.729z"
        fill="#2b4d66"
      />
      <path
        data-name="Path 7835"
        d="M82.519 63.349H68.962a2.012 2.012 0 00-1.815 1.131q-6.594 13.719.567 27.43h16.057q7.164-13.713.567-27.43a2.012 2.012 0 00-1.819-1.131z"
        fill="#df6b57"
      />
      <path
        data-name="Path 7836"
        d="M84.335 64.48a2.015 2.015 0 00-1.817-1.131h-4.244a2.013 2.013 0 011.817 1.131q6.594 13.719-.569 27.43h4.244q7.161-13.713.569-27.43z"
        fill="#dd544f"
      />
      <path
        data-name="Path 7837"
        d="M81.467 63.348h-11.45v-3.482a1.664 1.664 0 011.663-1.663h8.124a1.664 1.664 0 011.663 1.663z"
        fill="#365e7d"
      />
      <path
        data-name="Path 7838"
        d="M79.802 58.203h-3.165a1.661 1.661 0 011.663 1.663v3.482h3.167v-3.482a1.664 1.664 0 00-1.665-1.663z"
        fill="#2b4d66"
      />
      <path
        data-name="Path 7839"
        d="M8.767 25.354h14.4v12.52h-14.4z"
        fill="#df6b57"
      />
      <path
        data-name="Path 7840"
        d="M19.365 25.354h3.753v12.52h-3.753z"
        fill="#dd544f"
      />
      <path
        data-name="Path 7841"
        d="M44.965 70.472H5.015V65.34a19.975 19.975 0 0139.95 0z"
        fill="#e7ecf6"
      />
      <path
        data-name="Path 7842"
        d="M24.99 45.366q-.923 0-1.825.084a19.975 19.975 0 0118.15 19.89v5.132h3.649V65.34A19.974 19.974 0 0024.99 45.366z"
        fill="#d8e2f1"
      />
      <path
        data-name="Path 7843"
        d="M5.015 70.473h39.95v21.438H5.015z"
        fill="#e7ecf6"
      />
      <path
        data-name="Path 7844"
        d="M41.316 70.473h3.65v21.438h-3.65z"
        fill="#d8e2f1"
      />
      <path
        data-name="Path 7845"
        d="M30.386 91.911h-10.79v-8.9a1.077 1.077 0 011.077-1.077h8.636a1.077 1.077 0 011.077 1.077z"
        fill="#d3effb"
      />
      <path
        data-name="Path 7846"
        d="M29.309 81.938h-3.1a1.077 1.077 0 011.076 1.077v8.9h3.1v-8.9a1.077 1.077 0 00-1.076-1.077z"
        fill="#b1e4f9"
      />
      <path
        data-name="Path 7847"
        d="M28.093 59.93a3.103 3.103 0 01-6.206 0c0-1.715 1.389-5.093 3.1-5.093s3.106 3.378 3.106 5.093z"
        fill="#365e7d"
      />
      <path
        data-name="Path 7848"
        d="M24.99 54.839a1.765 1.765 0 00-1.146.5 7.289 7.289 0 011.957 4.592 3.1 3.1 0 01-1.957 2.881 3.1 3.1 0 004.249-2.881c0-1.716-1.389-5.092-3.103-5.092z"
        fill="#2b4d66"
      />
      <g data-name="Group 377">
        <path
          data-name="Path 7849"
          d="M91.911 90.545h-5.962a33.375 33.375 0 002.38-7.4 1.367 1.367 0 10-2.684-.516 31.258 31.258 0 01-2.717 7.914h-5.821v-2.1a1.367 1.367 0 00-2.733 0v2.1h-5.821a29.259 29.259 0 01-3.2-12.377 26.623 26.623 0 01.731-6.7h19.309a26.732 26.732 0 01.735 5.968 1.366 1.366 0 001.366 1.356h.01a1.366 1.366 0 001.356-1.377 29.345 29.345 0 00-.7-6.119 1.366 1.366 0 00-.661-2.562h-.018a35.249 35.249 0 00-1.912-4.847A3.393 3.393 0 0082.831 62v-2.134a3.032 3.032 0 00-2.978-3.027V6.914A6.921 6.921 0 0072.94 0H21.712A6.921 6.921 0 0014.8 6.913V9.77h-4.3a3.1 3.1 0 00-3.1 3.1v4.062a1.365 1.365 0 000 2.375v33.962a21.22 21.22 0 00-3.751 12.072v3.766h-.894a1.367 1.367 0 000 2.733h.894v7.368a1.367 1.367 0 102.733 0v-7.369H43.6v18.706H31.752v-7.53a2.446 2.446 0 00-2.443-2.443h-8.636a2.446 2.446 0 00-2.443 2.443v7.53H6.382V84.67a1.367 1.367 0 00-2.733 0v5.875H1.366a1.367 1.367 0 000 2.733h90.545a1.367 1.367 0 000-2.733zM20.962 83.3h8.057v7.24h-8.057zm51-26.469h-.282a3.033 3.033 0 00-3.03 3.03V62a3.394 3.394 0 00-2.735 1.891A35.2 35.2 0 0064 68.736h-.019a1.366 1.366 0 00-.66 2.563q-.307 1.395-.478 2.79H57.6V26.595a1.365 1.365 0 000-2.374v-4.062a3.1 3.1 0 00-3.1-3.1h-4.078v-3.607a2.467 2.467 0 012.464-2.464H69.5a2.467 2.467 0 012.464 2.464zM43.246 26.774h11.618v9.731H43.246zm0 12.464h11.618v9.787H43.246zM54.5 19.79a.369.369 0 01.368.368v3.883H43.246v-3.883a.369.369 0 01.368-.368zM40.513 36.25H24.532v-1.874h15.981zM21.752 23.988h-3.078a1.367 1.367 0 100 2.733h3.077v9.787H10.134v-9.787h3.077a1.367 1.367 0 100-2.733h-3.077v-4.5h11.618zm0 15.253v5a21.3 21.3 0 00-11.618 5.791V39.241zm2.733-.258h16c0 .277-.006 12.51.024 11.728A21.284 21.284 0 0024.991 44c-.169 0-.338 0-.506.006v-5.023zm18.761 12.775h11.618v12.633H46.31A21.2 21.2 0 0043.246 54.3zm3.979 20.081a1.367 1.367 0 100-2.733h-.893v-1.982h8.532v6.965h-8.532v-2.25h.893zm-.893 4.983h16.31q-.027.956.01 1.911h-16.32v-1.911zm16.554 4.644a32.447 32.447 0 002.647 9.08H57.6v-9.08zM83.1 65.073a33 33 0 011.5 3.663H66.878a32.987 32.987 0 011.5-3.662.649.649 0 01.585-.359h13.556a.648.648 0 01.581.358zm-3-5.207v2.116h-8.717v-2.116a.3.3 0 01.3-.3H79.8a.3.3 0 01.3.3zM17.531 6.913a4.186 4.186 0 014.181-4.181H72.94a4.186 4.186 0 014.18 4.182v49.922H74.7V13.452a5.2 5.2 0 00-5.2-5.2H52.886a5.2 5.2 0 00-5.2 5.2v3.605h-4.071a3.1 3.1 0 00-3.1 3.1v4.062a1.365 1.365 0 000 2.375v5.048H24.533c-.026-9.644.039 4.492-.048-12.336a1.365 1.365 0 000-2.375v-4.06a3.1 3.1 0 00-3.1-3.1h-3.854zM10.5 12.5h10.884a.369.369 0 01.368.368v3.883H10.134v-3.88a.369.369 0 01.366-.371zM6.38 69.1v-3.759a18.609 18.609 0 0137.218 0v3.766zm39.95 12.359h8.532v9.08h-8.53z"
        />
        <path
          data-name="Path 7850"
          d="M24.99 53.473c-1.294 0-2.5.932-3.4 2.629a8.975 8.975 0 00-1.068 3.83 4.469 4.469 0 108.938 0 8.982 8.982 0 00-1.068-3.83c-.9-1.699-2.112-2.629-3.402-2.629zm0 8.2a1.738 1.738 0 01-1.737-1.737c0-1.484 1.2-3.642 1.731-3.726.547.085 1.742 2.243 1.742 3.726a1.738 1.738 0 01-1.736 1.73z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
